import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { jwtDecode } from 'jwt-decode';
import get from 'lodash/get';
import getApolloClient from '../../apollo-client';
import createLocalLink from '../../../createLocalLink';
import { Container } from '../../components';
import CollegeEvents from '../CollegeEvents';

import './styles.css';
import { trackPageVisit } from '../../utils/tagmanager';

export default class MainContainer extends React.Component {
  // Prevent promise from executing after unmount
  _isMounted = false;

  constructor(props) {
    super(props);
    /* istanbul ignore next */
    console.log(
      `Starting Events App ${props.Footer ? 'With Footer' : 'Without Footer'} @ %s`,
      process.env.REACT_APP_VERSION || 'development',
    ); // eslint-disable-line no-console

    const {
      session,
      apiUrl,
      localLink = process.env.REACT_APP_MOCK_GRAPHQL === 'true' ? createLocalLink() : undefined,
      fcService,
    } = this.props;

    this.client = getApolloClient({
      session,
      uri: apiUrl,
      localLink,
      fcService,
    });

    this.state = {
      userInfo: {},
      isNewSession: false,
    };

    this.props.fcService.getUserInfo().then((info) => {
      /* istanbul ignore next */
      if (this._isMounted) this.setState({ userInfo: info });
    });
  }

  componentDidMount() {
    trackPageVisit();
    this._isMounted = true;
    this.checkSession();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  checkSession() {
    const jwt = get(this.props, 'session.jwt');
    if (!jwt) return;
    const decoded = jwtDecode(jwt);
    const jwtTokenIat = new Date(decoded.iat * 1000);
    const localStorageIat = new Date(parseInt(window.localStorage.getItem('iatkey')) || 0);
    window.localStorage.setItem('iatkey', jwtTokenIat.getTime());
    this.setState({ isNewSession: localStorageIat < jwtTokenIat });
  }

  render() {
    const { userInfo, isNewSession } = this.state;
    const { contextRef, Footer } = this.props;
    return (
      <ApolloProvider client={this.client}>
        <Container fluid>
          <CollegeEvents {...this.props} userInfo={userInfo} isNewSession={isNewSession} />
          {contextRef && contextRef.current && Footer && <Footer contextRef={contextRef.current} context="EVENTS" />}
        </Container>
      </ApolloProvider>
    );
  }
}
